import { TextInput } from '../../../components/TextInput';
import { newSampleKey } from '../../../utils/sampleDataTemplate';
import { SampleFieldset, SampleRow } from './SampleFormControls';
import { fieldId, removeTeam, replaceAt, type SampleSectionProps } from './templateEditing';

export const TeamsFieldset = ({ value, onChange, errorFor }: SampleSectionProps) => (
  <SampleFieldset
    legend="Teams"
    addLabel="Add team"
    addTestId="sample-data-add-team"
    onAdd={() => onChange({ ...value, teams: [...value.teams, { key: newSampleKey('team'), name: '' }] })}
  >
    {value.teams.map((team, index) => (
      <SampleRow
        key={team.key}
        label={`Team ${index + 1}`}
        removeLabel={`Remove team ${team.name || index + 1}`}
        removeTestId={`sample-data-remove-team-${index}`}
        onRemove={() => onChange(removeTeam(value, team.key))}
      >
        <TextInput
          id={fieldId(`teams[${index}].name`)}
          className="sample-form__field"
          label="Team name"
          value={team.name}
          error={errorFor(`teams[${index}].name`)}
          data-testid={`sample-data-team-name-${index}`}
          onChange={(e) =>
            onChange({ ...value, teams: replaceAt(value.teams, index, { name: e.target.value }) })
          }
        />
      </SampleRow>
    ))}
  </SampleFieldset>
);
